import React from 'react';
import ModalComponent from '../../components/ModalComponent';
import Button from 'react-bootstrap/Button';
import '../../assets/style/Modal.css';
import ModalHeader from '../../components/ModalHeader';
import successStartTick from '../../assets/img/sucessStarTick.svg';
import Image from 'react-bootstrap/Image';
import MarketingActivityDetails from '../../components/MarketingActivityDetails';
import { listTypes } from '../create-activity/activityHelper';

interface IMarketingActivitySucessModalProps {
  isOpen: boolean;
  toggleSuccessModal: () => void;
  type: string | null;
  activityDetails: any;
}

const MarketingActivitySucessModal: React.FunctionComponent<
  IMarketingActivitySucessModalProps
> = ({
  isOpen,
  toggleSuccessModal,
  type,
  activityDetails,
}: IMarketingActivitySucessModalProps) => {
  const handleClose = () => {
    toggleSuccessModal();
  };

  return (
    <ModalComponent
      isOpen={isOpen}
      toggle={() => {
        toggleSuccessModal();
      }}
      className="modalWrapper"
      backdrop="static"
    >
      <div className="bg-white rounded border overflow-hidden">
        <div className="p-2">
          <ModalHeader toggle={handleClose} closeOnly />
          <div className="d-flex justify-content-center">
            <Image
              src={successStartTick}
              roundedCircle
              width={100}
              height={100}
            />
          </div>
          <p className="text-center mt-3">
            A Sales Activity{' '}
            <b>&nbsp;{activityDetails?.activityUniqueId}&nbsp;</b> has been
            successfully {type === listTypes.create ? 'created' : 'approved'}.
          </p>

          <MarketingActivityDetails activity={activityDetails} />
        </div>
        <div className="d-flex justify-content-center re-button-parent">
          <Button
            variant="primary"
            className="cl-btn-primary"
            onClick={handleClose}
          >
            Close
          </Button>
        </div>
      </div>
    </ModalComponent>
  );
};

export default MarketingActivitySucessModal;
